module.exports = {"object":"value","document":{"object":"document","nodes":[{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"This is editable text that you can search. As you search, it looks for matching strings of text, and adds \"annotation\" marks to them in realtime."}]},{"object":"block","type":"paragraph","nodes":[{"object":"text","text":"Try it out for yourself by typing in the search box above!"}]}]}}


//////////////////
// WEBPACK FOOTER
// ./examples/search-highlighting/value.json
// module id = 1757
// module chunks = 0